import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { FormBuilder, FormControl, Validators, FormGroup } from '@angular/forms';
import { BaseComponent } from '../../base/base.component';
import { AccountService } from '../../../services/account.service';
import { CounsellorPersonalDetailsVM } from '../../../models/CounsellorPersonalDetailsVM';
import * as moment from 'moment';
import { OrganisationProfileVM } from '../../../models/OrganisationProfileVM';

@Component({
  selector: 'PersonalDetailsComponent',
  templateUrl: './personal-details.component.html'
})
export class PersonalDetailsComponent extends BaseComponent implements OnInit {

  model: OrganisationProfileVM = new OrganisationProfileVM();
  dateOfBirth = new Date();
  myForm: FormGroup;

  constructor(private fb: FormBuilder,
    private router: Router,
    private route: ActivatedRoute,
    private accService: AccountService
  ) {
    super(route);
  }

  ngOnInit(): void {
    this.accService.getProfile()
      .subscribe(r => {
        this.model.firstname = r.firstname;
        this.model.lastname = r.lastname;
        this.model.addressLine1 = r.addressLine1;
        this.model.addressLine2 = r.addressLine2;
        this.model.city = r.city;
        this.model.country = r.country;
        this.model.postcode = r.postcode;
        this.model.tel = r.tel;
      },
        error => {
          this.showDialog("Error loading information, please refresh page", true);
        },
        () => {
          this.emitDisplayLoadingDialog(false);
        }
      );

    this.myForm = this.fb.group({
      firstname: new FormControl('', Validators.required),
      lastname: new FormControl('', Validators.required),
      tel: new FormControl('', Validators.required),
      country: new FormControl('', Validators.required),
      state: new FormControl(null),
      addressLine1: new FormControl('', Validators.required),
      addressLine2: new FormControl(''),
      city: new FormControl('', Validators.required),
      postcode: new FormControl('', Validators.required)
    });
  }

  onSubmit(): void {
    this.markAsTouched(this.myForm);
    if (this.myForm.valid) {

      this.emitDisplayLoadingDialog(true);

      this.accService.updatePersonalDetails(this.model)
        .subscribe(
          result => {
            if (result) {
              this.showDialog("Changes saved successfully", false);
            }
            else {
              this.showDialog("Changes not saved, please try again", true);
            }
          },
          error => {
            this.showDialog("Changes not saved, please try again", true);
          },
          () => {
            this.emitDisplayLoadingDialog(false);
          }
        )


    }
  }
}
